import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '../../services/login-service/login.service';
import { LOGIN_PAGES } from '../login-process/enum-login-pages';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';
import { LoginModalComponent } from 'src/app/components/login-modal/login-modal.component';
import { ConfigService } from '../../services/config-service/config.service';

@Component({
  selector: 'app-launch-page',
  templateUrl: './launch-page.component.html',
  styleUrls: ['./launch-page.component.scss'],
})
export class LaunchPageComponent implements OnInit, OnDestroy {
  user: any = null;
  private userSubscription: Subscription = new Subscription();
  public config: any = null;
  hasAccessToRailPerformance = false;
  hasAccessToForecastAndDemand = false;
  loading = false;
  hasAccessToRailcarSearch = false;

  constructor(
    public dialogService: DialogService,
    private loginService: LoginService,
    private configService: ConfigService,
    private mixpanelService: MixpanelService,
    private router: Router
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig !== null) this.config = JSON.parse(strConfig);
    else {
      this.configService._config_$.subscribe((x) => {
        this.config = x;
      });
    }
  }

  ngOnInit(): void {
    this.userSubscription = this.loginService.user$.subscribe((user) => {
      this.user = user;
    });
    localStorage.removeItem('fromNewBuilds');

    this.loadUser();

    const storedEmail = localStorage.getItem('userEmail');
    if (storedEmail) {
      this.loginService.isTrinUser(storedEmail).subscribe({
        next: (isTrinUser) => {
          this.hasAccessToRailcarSearch = isTrinUser;
        },
        error: () => {
          this.hasAccessToRailcarSearch = false;
        },
      });
    }
  }

  public showLoginModal(application_type?: string): void {
    this.trackInitialLoadEvent();
    this.dialogService.open(LoginModalComponent, {
      data: {
        step: LOGIN_PAGES.SIGN_UP_SCREEN,
        application_type: application_type,
      },
      width: '980px',
      closeOnEscape: false,
    });
  }

  private trackInitialLoadEvent(email?: string): void {
    this.mixpanelService.track({
      id: email,
      eventName: 'Initial Get Started',
      eventDisplayName: 'Get Started Button Click',
      kpi: 'Click-Through Rate',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the get started button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button showLoginModal',
    });
  }

  checkAccess(email: string): void {
    this.loginService.checkAccessForRailPerformance(email).subscribe(
      (response) => {
        this.hasAccessToRailPerformance = response;
      },
      (error) => {
        this.hasAccessToRailPerformance = false;
        console.error('Error checking access for Rail Performance:', error);
      }
    );

    this.loginService.checkAccessForForecastAndDemand(email).subscribe(
      (response) => {
        this.hasAccessToForecastAndDemand = response;
      },
      (error) => {
        this.hasAccessToForecastAndDemand = false;
        console.error('Error checking access for Forecast and Demand:', error);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  navigateToDashboard() {
    this.router.navigate(['/search-inventory']);
  }

  navigateToRailPerformance() {
    window.location.href = this.config.railPerformanceURL;
  }

  navigateToRailPerformanceForecast() {
    window.location.href = this.config.railPerformanceForecastURL;
  }

  loadUser(): void {
    const userObservable = this.loginService.getUser();
    if (userObservable) {
      userObservable.subscribe({
        next: (response: any) => {
          const user = response[0]?.json_build_object;
          this.loginService.setUser(user);
          const userEmail = localStorage.getItem('userEmail') || '';
          this.checkAccess(userEmail);
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }
}
